import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
import { CurrencyFormat } from "utils/CurrencyFormat";
import ImgGlasse from "../../../../assets/imgOS.png";
import ActionButton from "../../../Button/ActionButton";
import LayoutDetails from "../../../LayoutModal/LayoutDetails";
import Loading from "../../../Loading";
import * as S from "./style";
import axios from "axios";
//Icons
import { Export } from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//Interface
import { IServiceOrder } from "Interfaces/IServiceOrder";
// utils
import FormatarData from "utils/FormatData";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {

  const [data, setData] = useState<IServiceOrder | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const listHeadLens = [
    "",
    "Esférico",
    "Cilindro",
    "Eixo",
    "DNP",
    "Altura",
    "Adição",
    "DNP V",
    "ALT",
  ];
  // Array com os nomes dos campos
  const fieldsOE = [
    "spherical_left",
    "cylindrical_left",
    "axis_left",
    "dnp_left",
    "height_left",
    "addition_left",
    "dnp_v_left",
    "alt_left"
  ] as const;

  const fieldsOD = [
    "spherical_right",
    "cylindrical_right",
    "axis_right",
    "dnp_right",
    "height_right",
    "addition_right",
    "dnp_v_right",
    "alt_right"
  ] as const;

  const listHeadLensPonte = [
    "Ponte",
    "Hori. Maior",
    "Vert. Maior",
    "Diag. Maior",
  ];

  const fieldsPonte = [
    "bridge",
    "larger_horizontal",
    "larger_vertical",
    "larger_diagonal"
  ] as const;

  const fetchData = async () => {
    startLoading();
    try {
      const response = await axiosInstance.get(`service-order/${selectedUrlId}`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalDetails && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalDetails, selectedUrlId]);

  const exportData = async () => {
    startLoading();
    try {
      await axios.get(`http://127.0.0.1:8000/export-service-order`);
    } catch (error) {
      alert(`Erro ao exportar dados: ${error}`);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Ordem de Serviço"
        subTitle="Veja todos os detalhes disponíveis sobre a O.S."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgGlasse} alt="Imagem Óculos" />
              </S.ContentImage>
              <S.ContentInfor>
                <S.Infor>
                  <p>Número da O.S:</p>
                  <span>{data.number_os || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Número da Venda:</p>
                  <span>{data.sale?.number_ata || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Preço:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.sale?.total_amount || "0"))}
                  </span>
                </S.Infor>
                <S.Infor>
                  <p>Data da Entrega:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.delivery || "0"))}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Cliente</p>
                    <span>{data.sale?.customer?.full_name || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>E-mail</p>
                    <span>{data.sale?.customer?.email || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>RG/CPF</p>
                    <span>{data.sale?.customer?.rg || "-"}/{data.sale?.customer?.cpf || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Data de Nascimento</p>
                    <span>{data.sale?.customer?.birth_date || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Nº Convênio</p>
                    <span>{data.sale?.customer?.number_agreement || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>

              {/* table */}
              <S.ContainerTable>
                <S.Table>
                  <S.Thead>
                    <S.Tr>
                      {listHeadLens.map((header) => {
                        return <th>{header}</th>;
                      })}
                    </S.Tr>
                  </S.Thead>

                  <S.Tbody>
                    <S.Tr>
                      <S.Td>OD</S.Td>
                      {
                        fieldsOD.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data?.[fieldName] || '-'}
                          </S.Td>
                        ))
                      }
                    </S.Tr>

                    <S.Tr>
                      <S.Td>OE</S.Td>
                      {
                        fieldsOE.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data?.[fieldName] || '-'}
                          </S.Td>
                        ))
                      }
                    </S.Tr>
                  </S.Tbody>
                </S.Table>

                <S.Table>
                  <S.Thead>
                    <S.Tr>
                      {listHeadLensPonte.map((header) => {
                        return <th>{header}</th>;
                      })}
                    </S.Tr>
                  </S.Thead>

                  <S.Tbody>
                    <S.Tr>
                      {
                        fieldsPonte.map((fieldName, index) => (
                          <S.Td key={index}>
                            {data?.[fieldName]}
                          </S.Td>
                        ))
                      }
                    </S.Tr>
                  </S.Tbody>
                </S.Table>
              </S.ContainerTable>

              {/* Sessão de valores */}
              <S.FeaturedSection>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Valor de Compra</p>
                    <span>
                      {CurrencyFormat(parseFloat(data.sale?.total_amount || "0"))}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Vendedor</p>
                    <span>{data.sale?.user.first_name || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Status</p>
                    <span>{data.sale?.status || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Forma de Pagamento</p>
                    <span>
                      {data.sale?.payment_method?.payment_method || "-"}
                    </span>
                  </S.InforBody>
                </S.ContentBody>
              </S.FeaturedSection>

              <S.InforBody>
                <p>Observação</p>
                <S.Description>{data.observation || "-"}</S.Description>
              </S.InforBody>

              <S.InforBody>
                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
              </S.InforBody>

              <S.ContentButton>
                <ActionButton
                  Icon={<Export size={24} />}
                  name={'Exportar O.S'}
                  onClick={() => toggleModalVisibility("barcode")}
                />
              </S.ContentButton>
            </S.Body>
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
